import { Editor } from "grapesjs";
import {
  BootstrapSizes,
  Button,
  ButtonColors,
  Modal,
} from "@talentech/components";
import { CustomCommands } from "../../../shared/utils";
import { useEditor } from "@grapesjs/react";
import { useEffect, useState } from "react";
import MediaLibrary from "@/components/MediaLibrary/MediaLibrary";

export default function useMediaLibrary() {
  const customMediaLibraryPlugin = (editor: Editor) => {
    editor.AssetManager.open = () => {
      editor.runCommand(CustomCommands.ASSET_MANAGER_OPEN);
    };

    editor.AssetManager.close = () => {
      editor.runCommand(CustomCommands.ASSET_MANAGER_CLOSE);
    };
  };

  return {
    customMediaLibraryPlugin,
    MediaLibraryModal: <MediaLibraryModal />,
  };
}

export const MediaLibraryModal = () => {
  const editor = useEditor();
  const [showModal, setShowModal] = useState(false);

  const [onSelectFn, setOnSelectFn] = useState<{fn: ((src: string) => void)} | null>(
    null
  );

  useEffect(() => {
    editor.Commands.add(
      CustomCommands.ASSET_MANAGER_OPEN,
      (_editor: Editor, _sender: any, opts: any) => {
        setShowModal(true);
        opts.onSelect && setOnSelectFn({fn: opts.onSelect});
      }
    );

    editor.Commands.add(CustomCommands.ASSET_MANAGER_CLOSE, () => {
      setShowModal(false);
    });
  }, []);

  const onSelect = (src: string) => {
    if (onSelectFn) {
      onSelectFn.fn(src);
      onClose();
      return;
    }
    const asset = editor.AssetManager.add(src);
    const selectedComponent = editor.getSelected();

    if (selectedComponent) {
      selectedComponent.is("image")
        ? selectedComponent.set("src", asset.getSrc())
        : selectedComponent.addStyle({
            "background-image": `url(${asset.getSrc()})`,
          });

        selectedComponent.is("video") && selectedComponent.set("src", asset.getSrc());
    } else {
      editor.AssetManager.add(asset.getSrc());
    }
    onClose();
  };

  const onClose = () => {
    editor.AssetManager.close();
  };

  return (
    <Modal
      showModal={showModal}
      onClose={onClose}
      title="Media Library"
      size={BootstrapSizes.XLARGE}
      buttons={[
        <Button
          key="close"
          label="Close"
          onClick={onClose}
          color={ButtonColors.PRIMARY}
        />,
      ]}
    >
      <MediaLibrary onSelect={onSelect} />
    </Modal>
  );
};
